import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const darkToastOptions: ToastOptions = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
};

export const showErrorNotification = (message: string) => {
    toast.error(message, darkToastOptions);
};

export const showSuccessNotification = (message: string) => {
    toast.success(message, darkToastOptions);
};

export const showWarningNotification = (message: string) => {
    toast.warn(message, darkToastOptions);
};
